const hotTopics = [
  { id: 1, label: '娱乐圈', title: '顶流塌房', desc: '最新明星翻车事件全记录', count: '128篇', tag: 'HOT', tagColor: 'bg-primary-500' },
  { id: 2, label: '网红圈', title: '大V互撕', desc: '知名网红恩怨局深度起底', count: '96篇', tag: 'NEW', tagColor: 'bg-accent-500' },
  { id: 3, label: '商业圈', title: '资本黑幕', desc: '企业内幕与商业暗箱操作', count: '73篇', tag: '爆', tagColor: 'bg-primary-500' },
  { id: 4, label: '直播圈', title: '主播风云', desc: '直播间背后的真实故事', count: '61篇', tag: '热', tagColor: 'bg-accent-500' },
  { id: 5, label: '科技圈', title: '产品翻车', desc: '科技产品虚假宣传揭露', count: '55篇', tag: 'NEW', tagColor: 'bg-accent-500' },
  { id: 6, label: '体育圈', title: '赛事黑料', desc: '体育界的台前幕后真相', count: '48篇', tag: 'HOT', tagColor: 'bg-primary-500' },
  { id: 7, label: '文学圈', title: '抄袭风波', desc: '文学作品剽窃事件追踪', count: '42篇', tag: '', tagColor: '' },
  { id: 8, label: '音乐圈', title: '版权大战', desc: '音乐圈版权纠纷全解析', count: '39篇', tag: '', tagColor: '' },
  { id: 9, label: '社会圈', title: '公共事件', desc: '社会热点事件真相还原', count: '35篇', tag: '', tagColor: '' },
];

const features = [
  { icon: 'ri-eye-line', title: '独家追踪', desc: '专业团队深入追踪每一条黑料线索，还原事件真相，绝不半途而废' },
  { icon: 'ri-timer-flash-line', title: '实时更新', desc: '24小时不间断监控全网动态，第一时间推送最新吃瓜内容与爆料信息' },
  { icon: 'ri-shield-check-line', title: '多重核实', desc: '每条爆料经多方交叉验证，确保信息准确可靠，拒绝虚假内容传播' },
  { icon: 'ri-group-line', title: '社区互动', desc: '百万吃瓜群众在线讨论，热门话题实时互动，吃瓜不再是一个人' },
];

const scandalCards = [
  {
    id: 1,
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20dramatic%20spotlight%20on%20an%20empty%20stage%20with%20a%20fallen%20microphone%2C%20warm%20crimson%20and%20gold%20lighting%2C%20theatrical%20composition%2C%20news%20magazine%20aesthetic%2C%20mysterious%20atmosphere%2C%20professional%20editorial%20photography&width=800&height=600&seq=card-01-91hl&orientation=landscape',
    tag: '独家爆料',
    title: '某知名网红涉嫌虚假宣传，品牌方已紧急撤下全部合作内容',
    excerpt: '据知情人士透露，该网红在直播带货中夸大产品功效，品牌方连夜删除了所有相关推广素材，多平台已暂停合作...',
    time: '3小时前',
    views: '12.8万',
  },
  {
    id: 2,
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20scene%20of%20scattered%20documents%20on%20a%20dark%20desk%20under%20warm%20ambient%20light%2C%20investigative%20journalism%20concept%2C%20rich%20amber%20and%20deep%20charcoal%20tones%2C%20professional%20photojournalism%20style%2C%20mysterious%20mood&width=800&height=600&seq=card-02-91hl&orientation=landscape',
    tag: '深度追踪',
    title: '资本圈又爆大瓜：某上市公司财务数据疑造假，股价异动引关注',
    excerpt: '该公司近三年财报多项指标出现异常波动，业内人士指出可能存在虚增收入的情况，监管层或已介入调查...',
    time: '5小时前',
    views: '9.6万',
  },
  {
    id: 3,
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20photography%20of%20two%20silhouetted%20figures%20facing%20each%20other%20under%20dramatic%20split%20lighting%2C%20confrontation%20theme%2C%20warm%20and%20cool%20contrasting%20tones%2C%20editorial%20magazine%20style%2C%20high%20contrast%20dramatic%20composition&width=800&height=600&seq=card-03-91hl&orientation=landscape',
    tag: '热门吃瓜',
    title: '两位顶流艺人后台争执录音流出，圈内人士纷纷站队表态',
    excerpt: '一段疑似后台对话录音在网络疯传，涉及多位一线艺人之间的恩怨纠纷，录音内容信息量巨大引发全网热议...',
    time: '8小时前',
    views: '18.3万',
  },
  {
    id: 4,
    img: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20photography%20of%20cracked%20glass%20with%20warm%20backlighting%2C%20breaking%20through%20concept%2C%20crimson%20and%20gold%20color%20palette%2C%20dramatic%20shadows%2C%20news%20magazine%20cover%20aesthetic%2C%20professional%20photography&width=800&height=600&seq=card-04-91hl&orientation=landscape',
    tag: '独家曝光',
    title: '知名MCN机构内部管理混乱，多名签约主播集体解约维权',
    excerpt: '该机构被曝拖欠主播分成款达数月之久，合同条款存在多处霸王条款，主播联合委托律师发起集体诉讼...',
    time: '12小时前',
    views: '7.2万',
  },
  {
    id: 5,
    img: 'https://readdy.ai/api/search-image?query=Professional%20editorial%20photography%20of%20a%20single%20spotlight%20on%20a%20dark%20stage%20with%20subtle%20smoke%2C%20mysterious%20revelation%20concept%2C%20warm%20theatrical%20lighting%2C%20deep%20shadows%2C%20cinematic%20composition%2C%20high-end%20magazine%20aesthetic&width=800&height=600&seq=card-05-91hl&orientation=landscape',
    tag: '实时追踪',
    title: '科技圈大地震：某手机品牌发布会前夕被曝参数造假',
    excerpt: '即将发布的新品在第三方测试中表现与宣传严重不符，多家科技媒体已收到匿名举报材料，事件持续发酵中...',
    time: '1天前',
    views: '11.5万',
  },
  {
    id: 6,
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20scene%20of%20a%20sealed%20envelope%20under%20warm%20spotlight%20on%20dark%20surface%2C%20leaked%20secret%20concept%2C%20rich%20amber%20gold%20tones%2C%20mysterious%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20professional%20photography&width=800&height=600&seq=card-06-91hl&orientation=landscape',
    tag: '深度揭秘',
    title: '某综艺节目剪辑恶意引导舆论，现场观众还原真实录制情况',
    excerpt: '多位参与节目录制的观众发声，指出节目组通过恶意剪辑制造矛盾，嘉宾在节目中的人设与真实表现差距巨大...',
    time: '1天前',
    views: '15.7万',
  },
  {
    id: 7,
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20multiple%20overlapping%20newspaper%20clippings%20with%20warm%20dramatic%20lighting%2C%20media%20scrutiny%20concept%2C%20crimson%20and%20charcoal%20color%20scheme%2C%20textured%20composition%2C%20professional%20news%20magazine%20aesthetic&width=800&height=600&seq=card-07-91hl&orientation=landscape',
    tag: '吃瓜前线',
    title: '直播界新一轮洗牌：头部平台被曝数据掺水，真实观看量成谜',
    excerpt: '第三方数据监测机构报告显示，多家直播平台的公开数据与实际流量存在巨大差距，广告主已开始要求第三方审计...',
    time: '2天前',
    views: '8.9万',
  },
];

export default function SectionsA() {
  return (
    <>
      {/* #index - 热门专题索引 */}
      <section id="index" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
              热门专题索引
            </h2>
            <p className="text-secondary-500 text-sm md:text-base max-w-xl mx-auto">
              覆盖娱乐圈、网红圈、商业圈等九大领域，一站式浏览最热黑料专题
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {hotTopics.slice(0, 5).map((t) => (
              <a
                key={t.id}
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="group relative bg-background-100 rounded-xl p-4 md:p-5 cursor-pointer hover:bg-background-200 transition-colors"
              >
                {t.tag && (
                  <span className={`absolute top-3 right-3 px-2 py-0.5 rounded-full text-[10px] font-bold text-white whitespace-nowrap ${t.tagColor}`}>
                    {t.tag}
                  </span>
                )}
                <div className="text-xs text-secondary-400 font-medium mb-2">{t.label}</div>
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {t.title}
                </h3>
                <p className="text-xs text-secondary-400 mb-3 line-clamp-2">{t.desc}</p>
                <span className="text-[11px] text-secondary-300">{t.count}</span>
              </a>
            ))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 mt-3 md:mt-4">
            {hotTopics.slice(5).map((t) => (
              <a
                key={t.id}
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="group relative bg-background-100 rounded-xl p-4 md:p-5 cursor-pointer hover:bg-background-200 transition-colors"
              >
                {t.tag && (
                  <span className={`absolute top-3 right-3 px-2 py-0.5 rounded-full text-[10px] font-bold text-white whitespace-nowrap ${t.tagColor}`}>
                    {t.tag}
                  </span>
                )}
                <div className="text-xs text-secondary-400 font-medium mb-2">{t.label}</div>
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {t.title}
                </h3>
                <p className="text-xs text-secondary-400 mb-3 line-clamp-2">{t.desc}</p>
                <span className="text-[11px] text-secondary-300">{t.count}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* #features - 平台优势 */}
      <section id="features" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
              为什么选择91黑料网
            </h2>
            <p className="text-secondary-500 text-sm md:text-base max-w-xl mx-auto">
              专业、及时、可信——我们坚持做全网最靠谱的吃瓜平台
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((f, i) => (
              <div key={i} className="bg-background-50 rounded-2xl p-6 md:p-8 text-center group hover:bg-primary-50/50 transition-colors">
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                  <i className={`${f.icon} text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-900 mb-3">{f.title}</h3>
                <p className="text-sm text-secondary-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #cards - 黑料爆料图文信息卡 */}
      <section id="cards" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14 gap-4">
            <div>
              <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
                黑料爆料
              </h2>
              <p className="text-secondary-500 text-sm md:text-base">
                最新最全的黑料吃瓜内容，实时追踪热点事件
              </p>
            </div>
            <a
              href="#updates"
              onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center gap-1.5 text-primary-500 hover:text-primary-600 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              查看更多 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {scandalCards.slice(0, 6).map((card) => (
              <article
                key={card.id}
                className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
              >
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-bold whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-secondary-500 leading-relaxed mb-4 line-clamp-2">
                    {card.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-secondary-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i> {card.time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {card.views}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-5 md:mt-6">
            <article className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow flex flex-col sm:flex-row">
              <div className="relative sm:w-72 md:w-96 h-48 sm:h-auto overflow-hidden shrink-0">
                <img
                  src={scandalCards[6].img}
                  alt={scandalCards[6].title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-bold whitespace-nowrap">
                  {scandalCards[6].tag}
                </span>
              </div>
              <div className="p-5 md:p-6 flex flex-col justify-center">
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {scandalCards[6].title}
                </h3>
                <p className="text-sm text-secondary-500 leading-relaxed mb-4">
                  {scandalCards[6].excerpt}
                </p>
                <div className="flex items-center gap-6 text-xs text-secondary-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {scandalCards[6].time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {scandalCards[6].views}
                  </span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}